import React, { useRef } from 'react';
import { gImage1, gImage2, gImage3, gImage4, gImage5, gImage6, gImage7, gImage8, gImage9, gImage10 } from '../../Assets/index';
import IMG_1 from "../../Assets/Images/gallery/APS_4.JPG";
import IMG_2 from "../../Assets/Images/gallery/APS_5.JPG";
import IMG_3 from "../../Assets/Images/gallery/APS_6.JPG";
import IMG_4 from "../../Assets/Images/gallery/APS_11.JPG";
import IMG_5 from "../../Assets/Images/gallery/APS_27.JPG";
import IMG_6 from "../../Assets/Images/gallery/APS_28.JPG";

const Gallery = () => {
    const GalleryImages = [
      { src: gImage1, name: 'Serenity' },
      { src: gImage2, name: 'Bliss' },
      { src: gImage3, name: 'Harmony' },
      { src: gImage4, name: 'Tranquility' },
      { src: gImage5, name: 'Euphoria' },
      { src: gImage6, name: 'Zen' },
      { src: gImage7, name: 'Radiance' },
      { src: gImage8, name: 'Solitude' },
      { src: gImage9, name: 'Wanderlust' },
      { src: gImage10, name: 'Dream scape' },
    ];

    return (
      <>
        <div className='container mx-auto pt-12 lg:pt-24 bg-gray-50 '>
          <div className='grid grid-cols-1 md:grid-cols-2 items-center gap-1 md:py-8 px-2 md:px-4 lg:px-6 animate-fadeInLeft' >
            <div className='text-3xl md:text-4xl lg:text-5xl font-semibold leading-normal text-gray-800 font-Pop tracking-wide'> A Glimpse into Our Work and Values </div>
            <div className='text-base md:text-lg text-gray-600 text-justify font-Pop font-medium'> Discover the heart of what we do through our gallery. It’s more than just projects; it’s a reflection of our passion, dedication, and the dynamic culture that fuels our success.
              <br />From innovative solutions to the spirit of collaboration within our team, each image showcases the essence of who we are and what we stand for.
              <br />Join us on a visual journey through our milestones, creativity, and the vibrant workplace that drives our achievements.
            </div>
          </div>
          <div className='grid grid-cols-3 sm:grid-cols-4 gap-3 lg:gap-8 mt-6 lg:mt-12 bg-gray-100 md:px-12 lg:px-28 h-[120vh] lg:py-24 px-3 lg:animate-fadeInRight'>
            {GalleryImages.map((item, index) => (
              <div className='relative overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 transform hover:scale-105' key={index} >
                <img className='w-full h-full object-cover transition-transform duration-500 ease-in-out' src={item.src} alt={item.name} />
                <div className='absolute inset-0 bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity duration-500 flex items-center justify-center'>
                  <p className='text-white font-semibold text-sm'>{item.name}</p>
                </div>
              </div>
            ))}
          </div>
          
        </div>

        <AutoCarousel images={IMAGES} />
            
      </>
    );
};
  
export default Gallery;


const AutoCarousel = ({ images }) => {
  const carouselRef = useRef(null);

  const handleMouseEnter = () => {
    if (carouselRef.current) {
      carouselRef.current.classList.add("paused");
    }
  };

  const handleMouseLeave = () => {
    if (carouselRef.current) {
      carouselRef.current.classList.remove("paused");
    }
  };

  const totalSets = images.length;
  const totalWidth = `${totalSets * 85}%`;
  const itemWidth = `${85 / totalSets}%`;

  return (
    <div
      ref={carouselRef}
      className="carousel-container overflow-hidden"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        className="carousel-track flex"
        style={{
          width: totalWidth,
        }}
      >
        {images.map((imageSet, index) => (
          <div key={index} className="flex-shrink-0 flex w-[100rem] h-56 md:h-full md:w-full">
            {imageSet.map((img, subIndex) => (
              <div key={subIndex} className="p-2" style={{ width: itemWidth }}>
                <img
                  src={img}
                  alt={`Image ${index * 4 + subIndex + 1}`}
                  className="md:w-full h-[22rem] object-cover rounded-lg shadow-lg" // Set a consistent height and use object-cover
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};


const IMAGES = [
  [IMG_1, IMG_2, IMG_3, IMG_4, IMG_5, IMG_6],
  [IMG_1, IMG_2, IMG_3, IMG_4, IMG_5, IMG_6],
];